import { Snackbar, Alert } from '@mui/material';

const MySnackbar = ({open, message, handleClose}) => {
  return (<Snackbar
    open={open}
    autoHideDuration={5000}  // Desaparece a los 10 segundos
    onClose={handleClose}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
  >
    <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
      {message}
    </Alert>
  </Snackbar>      
  );
}

export default MySnackbar;